'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('./index.js');

function useIframeQuery(options) {
  const [queryStatus, setQueryStatus] = React.useState({
    data: null,
    loading: true,
    error: null
  });
  React.useEffect(() => {
    const getInitialData = async () => {
      try {
        const response = await index.iframeQuery(options);
        setQueryStatus({
          data: response,
          loading: false,
          error: null
        });
      } catch (e) {
        setQueryStatus({
          data: null,
          loading: false,
          error: e
        });
      }
    };
    getInitialData()
    // eslint-disable-next-line no-console
    .catch(e => console.error(e));
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  return queryStatus;
}

exports.useIframeQuery = useIframeQuery;
